import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { api, API } from "@/lib/api";
import { AdminTitle } from "@/admin/AdminLayout";

const thumb = (u: string) => (u.startsWith("/api/") ? `${API}${u.slice(4)}` : u);

function Row({ r }: { r: any }) {
  const old = r.copy_url || r.old_url;
  return (
    <li className="grid grid-cols-[minmax(0,1fr)_96px_20px_96px] items-center gap-3 py-3 border-t border-neutral-100" data-testid={`replaced-row-${r.id}`}>
      <span className="text-sm">{r.section}</span>
      <a href={thumb(old)} target="_blank" rel="noreferrer" title="Removed photo (saved copy)"><img src={thumb(old)} alt="Removed" loading="lazy" className="w-24 h-16 object-cover opacity-80" /></a>
      <ArrowRight size={14} className="text-neutral-400" />
      <a href={r.new_url} target="_blank" rel="noreferrer" title="New photo"><img src={r.new_url} alt="New" loading="lazy" className="w-24 h-16 object-cover" /></a>
    </li>
  );
}

export default function ReplacedPhotos() {
  const [rows, setRows] = useState<any[] | null>(null);
  useEffect(() => { api.get("/admin-x/replaced-photos").then((r) => setRows(r.data)); }, []);
  const pages: Record<string, any[]> = (rows || []).reduce((m: Record<string, any[]>, r) => ({ ...m, [r.page_title]: [...(m[r.page_title] || []), r] }), {});
  return (
    <div data-testid="replaced-photos-page">
      <AdminTitle title="Replaced Photos" />
      <p className="text-sm text-neutral-600 mb-6 max-w-3xl">
        Every photo swapped in the sitewide refresh, page by page: the removed photo (left) and its replacement (right). A copy of each removed photo is kept in your image library
        (named "Replaced photo …"), so you can put any of them back from the page editor.
      </p>
      {rows && <p className="eyebrow text-[10px] text-neutral-500 mb-4" data-testid="replaced-photos-count">{rows.length} photos replaced on {Object.keys(pages).length} pages</p>}
      <div className="grid lg:grid-cols-2 gap-5">
        {Object.entries(pages).map(([title, list]) => (
          <section key={title} className="bg-white border border-neutral-200 p-5" data-testid={`replaced-page-${list[0].page_slug}`}>
            <div className="flex justify-between items-baseline mb-1">
              <h3 className="font-display text-lg">{title}</h3>
              <a href={`/pages/${list[0].page_slug}`} target="_blank" rel="noreferrer" className="text-xs underline">View page</a>
            </div>
            <ul>{list.map((r) => <Row key={r.id} r={r} />)}</ul>
          </section>
        ))}
      </div>
    </div>
  );
}
